import React from 'react';
import { CheckSquare, ChevronRight } from 'lucide-react';
import { TASK_PRIORITY } from '../crmShared';

const NEU = '5px 5px 10px rgba(186,199,216,0.45), -5px -5px 10px rgba(255,255,255,0.85)';

function fmtDate(d) {
  if (!d) return '—';
  const dt = new Date(d);
  const today = new Date();
  if (dt.toDateString() === today.toDateString()) return 'Today';
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  if (dt.toDateString() === tomorrow.toDateString()) return 'Tomorrow';
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function isOverdue(d) {
  if (!d) return false;
  return new Date(d) < new Date(new Date().toDateString());
}

export default function TasksSection({ rows, count, isTeam, onSeeAll, onRowClick }) {
  const visible = (rows || []).slice(0, 5);
  const p = TASK_PRIORITY;

  if (!visible.length) {
    return (
      <div className="my-day-card">
        <SectionHeader icon={<CheckSquare size={15} color="#2E8B98" />} title="Tasks due" count={count} onSeeAll={onSeeAll} />
        <p style={{ fontSize: 12, color: '#6C757D', margin: '12px 0 0', textAlign: 'center' }}>Nothing on your plate — clear queue!</p>
      </div>
    );
  }

  return (
    <div className="my-day-card">
      <SectionHeader icon={<CheckSquare size={15} color="#2E8B98" />} title="Tasks due" count={count} onSeeAll={onSeeAll} />
      <div className="responsive-scroll">
        <table style={{ width: '100%', minWidth: 340, borderCollapse: 'collapse', fontSize: 12, marginTop: 8 }}>
          <thead>
            <tr style={{ color: '#ADB5BD', fontWeight: 600 }}>
              <th style={th}>Priority</th>
              <th style={{ ...th, textAlign: 'left' }}>Task</th>
              <th style={th}>Due</th>
              {isTeam && <th style={th}>Owner</th>}
            </tr>
          </thead>
          <tbody>
            {visible.map(t => {
              const pri = p[t.priority] || p.normal;
              const overdue = isOverdue(t.due_date);
              const clickable = onRowClick && t.contact_id;
              return (
                <tr
                  key={t.id}
                  className={clickable ? 'my-day-row-clickable' : ''}
                  onClick={clickable ? () => onRowClick(t) : undefined}
                  tabIndex={clickable ? 0 : undefined}
                  onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRowClick(t); } } : undefined}
                  style={{ borderTop: '1px solid #F0F0F0' }}
                >
                  <td style={{ ...td, textAlign: 'center' }}>
                    <span style={{ background: pri.bg, color: pri.color, padding: '2px 7px', borderRadius: 8, fontWeight: 700, fontSize: 10 }}>
                      {pri.label}
                    </span>
                  </td>
                  <td style={td}>
                    <span style={{ color: '#212529', fontWeight: 500 }}>{t.title}</span>
                    {(t.first_name || t.last_name) && (
                      <span style={{ color: '#ADB5BD', marginLeft: 5 }}>— {t.first_name} {t.last_name}</span>
                    )}
                  </td>
                  <td style={{ ...td, textAlign: 'center', color: overdue ? '#DC3545' : '#495057', fontWeight: overdue ? 700 : 400 }}>
                    {fmtDate(t.due_date)}
                  </td>
                  {isTeam && <td style={{ ...td, textAlign: 'center', color: '#6C757D' }}>{t.assignee_name || '—'}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {onSeeAll && <SeeAllLink onSeeAll={onSeeAll} />}
    </div>
  );
}

function SectionHeader({ icon, title, count, onSeeAll }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {icon}
        <span style={{ fontSize: 13, fontWeight: 700, color: '#212529' }}>{title}</span>
        {count > 0 && <span className="my-day-count-badge active">{count}</span>}
        {count === 0 && <span className="my-day-count-badge">0</span>}
      </div>
    </div>
  );
}

function SeeAllLink({ onSeeAll }) {
  return (
    <button onClick={onSeeAll} style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 10, background: 'none', border: 'none', color: '#2E8B98', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
      See all <ChevronRight size={13} />
    </button>
  );
}

const th = { padding: '4px 8px', fontWeight: 600, fontSize: 11, color: '#ADB5BD', textAlign: 'center' };
const td = { padding: '7px 8px', color: '#495057' };
